export default {
  error_param: 'พารามิเตอร์ผิดพลาด',
  loading: 'กำลังโหลด...',
  version: 'เวอร์ชัน',
  size: 'ขนาด',
  query_failed: 'ค้นหาล้มเหลว',
  for_ios: 'สำหรับ iOS',
  for_android: 'สำหรับ Android',
  install: 'ติดตั้ง'
}
